var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:'btn py-3 loading-button loadable-button ' + _vm.additionalClasses},[(_vm.loading)?_c('div',{staticClass:"loader-wrapper"},[_c('Loader')],1):_c('div',[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }